<template>
  <div class="home wrapper">
    <div class="content">
      <Header></Header>
      <Loading :loading="loading"></Loading>

      <div :class="{ 'hidden': loading }">
        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>
        <Title :title="categoryName"></Title>

        <div class="container items-container">

          <div class="row">
            <div class="col-12 col-md-2">
              <YearsFilter></YearsFilter>
            </div>
            <!-- /.col-12 col-md-2 -->

            <div class="col-12 col-md-4">
              <BranchsFilter></BranchsFilter>
            </div>
            <!-- /.col-12 col-md-4 -->

            <div class="col-12 col-md-4">
              <ExpensesFilter></ExpensesFilter>
            </div>
            <!-- /.col-12 col-md-4 -->
          </div>
          <!-- /.row -->

          <div class="row mt-2">

            <div :class="{ 'col-12 hidden': loading, 'col-12': !loading }">

              <div class="expenses-list-header">
                <ul>
                  <li class="expenses-list-header-name">
                    Mês
                  </li>
                  <!-- /.expenses-list-header-item -->

                  <li class="expenses-list-header-price">
                    Valor
                  </li>
                  <!-- /.expenses-list-header-item -->
                </ul>
              </div>
              <!-- /.expenses-list-header -->

              <div class="expenses">
                <ul class="expenses-list">

                  <router-link
                    class="expenses-item"
                    tag="li"
                    :to="{name: 'despesas-internas', params: {branch: branch, year: year, category: category, month: expense.slug}}"
                    v-for="expense in expenses"
                    v-if="expense.price"
                  >
                    <div class="expenses-item-name">
                      <span>{{ expense.month }}</span>
                      <small>Mês</small>
                    </div>
                    <!-- /.expenses-item-name -->

                    <div class="expenses-item-price">
                      <span>R$ {{ expense.price.toLocaleString('pt-BR') }}</span>
                      <small>Valor</small>
                    </div>
                    <!-- /.expenses-item-price -->
                  </router-link>
                  <!-- /.expenses-item -->

                  <li class="expense-item-total">
                    <span>Total:</span>
                    <strong>R$ {{ total.toLocaleString('pt-BR') }}</strong>
                  </li>
                  <!-- /.expense-item-total -->

                </ul>
                <!-- /.expenses-list -->
              </div>
              <!-- /.expenses -->

            </div>
            <!--== /.col-12 ==-->

          </div>
          <!-- /.row -->

          <Loading :loading="loading"></Loading>

        </div>
        <!-- /.container -->

      </div>
      <!--== /.hidden ==-->
    </div>
    <!-- /.content -->

    <Footer></Footer>
  </div>
  <!-- /.home wrapper -->
</template>

<script>
  import Header from '../../components/Header.vue';
  import Footer from '../../components/Footer.vue';
  import Breadcrumb from '../../components/Breadcrumb.vue';
  import Arquivo from '../../components/generic/Arquivo.vue';
  import Title from '../../components/generic/Title.vue';
  import Loading from '../../components/generic/Loading.vue';
  import YearsFilter from '../../components/generic/Filters/Years.vue';
  import BranchsFilter from '../../components/generic/Filters/Branchs.vue';
  import ExpensesFilter from '../../components/generic/Filters/Expenses.vue';
  import axios from 'axios';
  import env from '../../config/env';

  export default {
    name: 'descricaomesesdespesas',
    components: {
      Header,
      Footer,
      Breadcrumb,
      Arquivo,
      Title,
      Loading,
      YearsFilter,
      BranchsFilter,
      ExpensesFilter,
    },
    data () {
      return {
        expenses: [],
        loading: true,
        categoryName: 'Transparência',
        year: this.$route.params.year,
        branch: this.$route.params.branch,
        category: this.$route.params.category,
        breadcrumbs: [
          {
            name: 'Início',
            link: '/'
          },
          {
            name: 'Orçamentos e Finanças',
            link: '/orcamentosefinancas'
          },
          {
            name: 'Despesas da OAB',
            link: `/orcamentosefinancas/despesas/${this.$route.params.branch}/${this.$route.params.year}`
          }
        ]
      }
    },
    mounted () {
      this.requestData();
    },
    methods: {
      requestData() {
        axios
          .get(`${env.api.DESPESAS_POR_MES}/${this.$route.params.branch}/${this.$route.params.year}/${this.$route.params.category}`)
          .then(response => {
            this.expenses = response.data.items;
            this.loading = false;
            this.year = this.$route.params.year;
            this.categoryName = response.data.categoryName;

            if (Object.keys(this.breadcrumbs).length > 4) {
              this.breadcrumbs[Object.keys(this.breadcrumbs).length - 2].name = this.categoryName;
            } else {
              this.breadcrumbs.push({
                name: this.categoryName
              });
            }
          });
      }
    },
    computed : {
      total: function() {
        if (!this.expenses) return 0;

        return this.expenses.reduce((sum, item) => sum + item.price, 0);
      }
    },
    watch: {
      '$route' () {
        this.loading = true;

        this.requestData();
      }
    }
  };
</script>

<style lang="scss" scoped>
  input,
  select,
  .btn {
    box-shadow: none !important;
  }

  input,
  select {
    height: 40px;

    box-shadow: none;
  }

  .btn {
    width: 100%;
    height: 40px;
  }

  .expenses-list-header {
    display: none;
  }

  .header-fixed {
    position: fixed !important;
    top: 100px;
  }

  .expenses-list-header,
  .expenses {
    ul {
      padding: 0;
      margin: 0;

      li {
        padding: 10px;

        list-style: none;

        background-color: #ffffff;

        &:nth-of-type(odd) {
          background-color: #f1f1f1;
        }
      }
    }
  }

  .expenses-list-header-item,
  .expenses-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    font-family: 'Lato', sans-serif;
    line-height: 1;

    span {
      display: block;

      color: #333333;
    }

    small {
      font-weight: 700;
      color: #000000;
    }
  }

  .expenses-item {
    cursor: pointer;

    &:hover {
      background-color: #dddddd !important;
    }
  }

  .expenses-item-name {
    flex: 0 0 100%;
  }

  .expenses-item-price {
    flex: 0 0 50%;
    margin-top: 10px;

    span {
      color: #ca4d40;
    }
  }

  .expenses-filter {
    select,
    input {
      height: 50px;

      font-family: 'Lato', sans-serif;
      font-size: 20px;
      font-weight: 300;

      box-shadow: none;
    }
  }

  .expense-item-total {
    font-family: 'Lato', sans-serif;
    text-align: right;

    strong {
      font-size: 18px;
      font-weight: 700;
    }
  }

  @media (min-width: 768px) {
    .expenses-list-header-name,
    .expenses-item-name {
      flex: 0 0 47%;
    }

    .expenses-list-header-role,
    .expenses-item-role {
      flex: 0 0 30%;

      margin: 0;
    }

    .expenses-list-header-price,
    .expenses-item-price {
      flex: 0 0 13%;

      margin: 0;
    }
  }

  @media (min-width: 1024px) {
    .expenses-item {
      padding: 20px 10px !important;

      small {
        display: none;
      }
    }

    .expenses-list-header {
      display: block !important;
      width: 1110px;

      ul {
        display: flex;
        justify-content: space-between;
      }

      ul,
      li {
        background-color: #c34338 !important;
      }

      li {
        padding: 20px 10px !important;

        font-weight: 700;
        color: #ffffff;
      }
    }

    .expenses-list-header-price,
    .expenses-item-price {
      text-align: right;
    }
  }
</style>
